import {z} from 'zod';

import i18n from '@dms/i18n';

export const jobInputFormSchema = z.object({
  job: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .trim()
    .min(1, {message: i18n.t('general.validations.fieldIsRequired')}),
});

export type JobInputFormType = z.infer<typeof jobInputFormSchema>;
